// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__yVDA0","noInteraction":"EventWrapper_noInteraction__2wDTT"};